import { useEffect, useState } from "react";
import SettingStore from "../../../store/Setting/Setting.store";
import Body from "./Body";
import ProductOverview from "../../../components/PagesComponents/Setting/ProductCube/ProductOverview/ProductOverview.component";
import ProductInfo from "../../../components/PagesComponents/Setting/ProductCube/ProductInfo/ProductInfo.component";
import Licensing from "../../../components/PagesComponents/Setting/ProductCube/Licensing/Licensing.component";
import TermAndPolicies from "../../../components/PagesComponents/Setting/ProductCube/TermAndPolicies/TermAndPolicies.component";
import LegalAttributes from "../../../components/PagesComponents/Setting/ProductCube/LegalAttributes/LegalAttributes.component";
import ContactInfo from "../../../components/PagesComponents/Setting/ProductCube/ContactInfo/ContactInfo.component";

const ProductCube = () => {
  const { currentTab, setCurrentTab } = SettingStore(); //admininfo,basicinfo,advanceinfo,documentinfo
  const [pageDetails, setPageDetails] = useState([
    {
      title: "Product overview",
      pathName: "productOverview",
    },
    {
      title: "Product info",
      pathName: "productInfo",
    },
    {
      title: "Licensing",
      pathName: "licensing",
    },
    {
      title: "Terms & policies",
      pathName: "termsAndPolicies",
    },
    {
      title: "Legal attribute",
      pathName: "legalAttribute",
    },
    {
      title: "Contact info",
      pathName: "contactInfo",
    },
  ]);
  const componentMap = {
    productOverview: <ProductOverview/>,
    productInfo: <ProductInfo/>,
    licensing: <Licensing/>,
    termsAndPolicies: <TermAndPolicies/>,
    legalAttribute: <LegalAttributes/>,
    contactInfo: <ContactInfo/>,
  };

  const handelCurrentTab = () => {
    return componentMap[currentTab] || <div>Select a valid tab</div>;
  };

  useEffect(() => {
    setCurrentTab("licensing");
  }, [setCurrentTab]);
  const _this = {
    handelCurrentTab,
    currentTab,
    setCurrentTab,
    pageDetails,
    setPageDetails,
  };
  return <Body {..._this} />;
};

export default ProductCube;
